import type { FC } from 'react';
import type { UnitToggleConfig } from '../../../config/tpoGenConfig';

interface UnitToggleProps {
    config: UnitToggleConfig;
    value: string | undefined;
    onChange: (value: string) => void;
    disabled: boolean;
}

const UnitToggle: FC<UnitToggleProps> = ({ config, value, onChange, disabled }) => {
    const activeValue = value ?? config.defaultValue ?? config.options[0]?.value;
    return (
        <div className="flex items-center gap-1 select-none">
            {config.options.map((opt) => {
                const isActive = activeValue === opt.value;
                return (
                    <span
                        key={opt.value}
                        onClick={() => {
                            if (disabled) return;
                            onChange(opt.value);
                        }}
                        className={`px-1 text-xs cursor-pointer ${
                            isActive ? 'font-bold text-purpleFont' : 'text-gray-400'
                        } ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                    >
                        {opt.label}
                    </span>
                );
            })}
        </div>
    );
};

UnitToggle.displayName = 'UnitToggle';

export default UnitToggle;
